import React, { useEffect } from 'react';
import { useFrame } from 'react-frame-component';
import { SCRIPT_ID } from '../../config';

type WithStyleWrapperProps = {
	children: React.ReactElement;
};

function getSelector() {
	if (process.env.STORYBOOK_BUILD_ENV === 'production') {
		return 'link[rel="stylesheet"]';
	}

	if (process.env.NODE_ENV === 'production') {
		return `[data-style-id=style-${SCRIPT_ID}]`;
	}

	return 'style';
}

export function WithStyleWrapper({ children }: WithStyleWrapperProps) {
	const { document: doc } = useFrame();
	const selector = getSelector();

	useEffect(() => {
		document.head.querySelectorAll(selector).forEach((style) => {
			const frameStyles = style.cloneNode(true);
			doc?.head?.append(frameStyles);
		});
	}, []);

	return <section>{children}</section>;
}
